import React from 'react';
import CatalogoP from '../catalagobase/catalogobase';
import Navbar from '../../components/navbar/navbar';
import Sidebar from '../../components/sidebar/sidebar';
import { API_URLS } from '../../Services/servicioURL';


function Unidades() {
    return (
        <div>
            <Navbar />
            <Sidebar />
            <CatalogoP title="Unidades" apiUrls={API_URLS.unidades}/>
        </div>
        
    
    );
}

export default Unidades;